export default {
  "canvas": "_canvas_15p69t",
  "video": "_video_15p69t"
};